import { TransactionStatuses } from '@insurance/types'
import { Tag, TagProps } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = {
  status?: TransactionStatuses
}

const statusColors: Record<TransactionStatuses, TagProps['color']> = {
  [TransactionStatuses.AUTHORIZED]: 'orange',
  [TransactionStatuses.ERROR]: 'volcano',
  [TransactionStatuses.CANCELED]: 'error',
  [TransactionStatuses.CREATED]: 'geekblue',
  [TransactionStatuses.PROCESSING]: 'yellow',
  [TransactionStatuses.UNKNOWN]: 'default',
  [TransactionStatuses.REFUNDED]: 'blue',
  [TransactionStatuses.SUCCEEDED]: 'green',
  [TransactionStatuses.PENDING]: 'magenta',
  [TransactionStatuses.TIMEOUT]: 'gold-inverse'
}

export const TransactionStatusTag = ({ status }: Props) => {
  const { t } = useTranslation()

  if (!status) return null

  return <Tag color={statusColors[status]}>{t(status)}</Tag>
}
